import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CONTACT_PATH, routeTo } from "@/lib/site";
import { MaskReveal, Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";

const GROUPS = [
  "Family reunions",
  "Birthday celebrations",
  "Fishing groups",
  "Business meetings",
  "Holiday events",
  "Work crews",
  "Extended group stays",
] as const;

export function GroupStaysSection() {
  const photo = PHOTOS.clubhouse;

  return (
    <section
      className="texture-paper bg-background py-24 sm:py-28 lg:py-32"
      aria-labelledby="groups-title"
    >
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-10">
        <div>
          <Reveal>
            <p className="eyebrow text-clay">The Perfect Place to Gather</p>
            <h2
              id="groups-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              Family Reunions, Celebrations and Group Stays
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
              Amigo Inn &amp; RV Park offers accommodations and gathering spaces for family
              reunions, birthday celebrations, fishing groups, business meetings, holiday events,
              work crews, and other group stays.
            </p>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
              Whether your group is visiting for a special occasion or needs accommodations for an
              extended period, contact the park to discuss the available options.
            </p>
          </Reveal>

          <ul className="mt-9 flex flex-wrap gap-2.5">
            {GROUPS.map((item, i) => (
              <Reveal as="li" key={item} delay={i * 0.04}>
                <span className="inline-flex rounded-full border border-forest/20 bg-surface px-4 py-2 text-xs font-semibold text-forest-deep">
                  {item}
                </span>
              </Reveal>
            ))}
          </ul>

          <Reveal delay={0.1} className="mt-10">
            <Button asChild variant="forest" size="cta">
              <Link to={routeTo(CONTACT_PATH)}>
                Plan a Group Stay <ArrowRight aria-hidden="true" />
              </Link>
            </Button>
          </Reveal>
        </div>

        <MaskReveal className="media-zoom rounded-sm">
          <img
            src={photo.src}
            srcSet={photo.srcSet}
            sizes={PHOTO_SIZES.half}
            alt={photo.alt}
            width={photo.width}
            height={photo.height}
            loading="lazy"
            decoding="async"
            className="aspect-[5/4] w-full rounded-sm object-cover"
          />
        </MaskReveal>
      </div>
    </section>
  );
}
